module.exports = __webpack_public_path__ + "img/receipt3.93930b5a.png";